import React, { useCallback, useContext, useMemo } from 'react';

import { SceneCanvasContext } from './SceneCanvasContext';

interface MousePosition {
  x: number;
  y: number;
}

type GetMousePositionFn = (
  event: React.MouseEvent | MouseEvent
) => MousePosition;

export const useGetMousePositionFromEvent = (): GetMousePositionFn => {
  const {
    svg: { getContainerCTM },
  } = useContext(SceneCanvasContext);

  const ctm = useMemo(() => {
    return getContainerCTM();
  }, [getContainerCTM]);

  const getMousePosition = useCallback(
    (event: React.MouseEvent | MouseEvent) => {
      const absoluteMouseX = event.clientX;
      const absoluteMouseY = event.clientY;

      const mouseX = (absoluteMouseX - ctm.e) / ctm.a;
      const mouseY = (absoluteMouseY - ctm.f) / ctm.d;

      return { x: mouseX, y: mouseY };
    },
    [ctm.a, ctm.d, ctm.e, ctm.f]
  );

  return getMousePosition;
};
